export default __webpack_public_path__ + "static/media/Marianne-Medium.348b5a56.woff";